import {FC, useRef, useState, useEffect} from 'react'
import {IProductTableFilter, ProductsTableFilterInitialState, IBrandModel, ISelectOptions} from '../cors/_models'
import TextTableFilter from '../../common/TextTableFilter'
import InputField from '../components/InputField'
import {useSearchParams} from 'react-router-dom'
import { useIntl } from 'react-intl'
import { getBrands } from '../cors/_requests'
import SharedData from '../../common/SharedData'

interface IProps {
  // setResultFilters: React.Dispatch<React.SetStateAction<IProductTableFilter>>
  // resultFilters: IProductTableFilter
}


export const ProductsTableFilter: FC<IProps> = ({}) => {
  const {formatMessage} = useIntl();
  const {currentUser, language} = SharedData()
  const [searchParams, setSearchParams] = useSearchParams()
  const [nameFilter, setNameFilter] = useState(searchParams.get('filter_name') || '')
  const [barcodeFilter, setBarcodeFilter] = useState(searchParams.get('filter_barcode') || '')
  const [modelFilter, setModelFilter] = useState(searchParams.get('filter_model') || '')
  const [qtyFilter, setQtyFilter] = useState(searchParams.get('filter_quantity') || '')
  const [specialFilter, setSpecialFilter] = useState(searchParams.get('filter_special') || '')
  const [isPackageFilter, setIsPackageFilter] = useState(searchParams.get('filter_is_package') || '')
  const [brandFilter, setBrandFilter] = useState(searchParams.get('filter_brand') || '')
  const [statusFilter, setStatusFilter] = useState(searchParams.get('filter_status') || '')
  const [stockFilter, setStockFilter] = useState(searchParams.get('filter_stock') || '')
  const [brandOptions, setBrandOptions] = useState<ISelectOptions[]>([])

  useEffect(() => {
    const fetchBrands = async () => {
      if (!currentUser?.token) return
      try {
        const { data } = await getBrands(currentUser.token, language)
        const formattedOptions = data.map((item: IBrandModel) => ({
          label: item.name,
          value: String(item.manufacturer_id)
        }))

        setBrandOptions([
          { label: formatMessage({ id: 'all' }), value: '' },
          ...formattedOptions
        ])
      } catch (error) {
        console.error("Error fetching brands:", error)
        setBrandOptions([{ label: formatMessage({ id: 'all' }), value: '' }])
      }
    }
    fetchBrands()
  }, [currentUser, language, formatMessage])

  const handleChange = (id: string, value: string, type: string) => {
    if (value) {
      searchParams.set(id, value)
      searchParams.set('current_page', '1')
    } else {
      searchParams.delete(id)
    }
  }

  const handleBrandChange = (e: { target: { id: string; value: string } }) => {
    const { value } = e.target
    setBrandFilter(value)
    handleChange('filter_brand', value, 'select')
  }

  const handleSpecialChange = (e: { target: { id: string; value: string } }) => {
    const { value } = e.target
    setSpecialFilter(value)
    handleChange('filter_special', value, 'select')
  }

  const filter = (): void => {
    const nextParams = new URLSearchParams(window.location.search)
    const filters = {
      filter_name: nameFilter,
      filter_barcode: barcodeFilter,
      filter_model: modelFilter,
      filter_quantity: qtyFilter,
      filter_special: specialFilter,
      filter_is_package: isPackageFilter,
      filter_brand: brandFilter,
      filter_status: statusFilter,
      filter_stock: stockFilter,
    }

    Object.entries(filters).forEach(([key, value]) => {
      if (value) nextParams.set(key, value)
      else nextParams.delete(key)
    })
    nextParams.set('current_page', '1')
    setSearchParams(nextParams, {replace: true})
  }
  
  const clearFilters = (): void => {
    setSearchParams({},{
      replace:true
    })
    setNameFilter('')
    setBarcodeFilter('')
    setModelFilter('')
    setQtyFilter('')
    setBrandFilter('')
    setStatusFilter('')
    setStockFilter('')
    setSpecialFilter('')
    setIsPackageFilter('')
  }

  return (
    <>
      <div className='hsb-pl-filter-card'>
        <form className='hsb-pl-filter-grid' onSubmit={(event) => { event.preventDefault(); filter() }}>
          {/* start product Name */}
          <TextTableFilter
            id='filter_name'
            label={formatMessage({ id: "prod_name" })}
            value={nameFilter}
            setValue={setNameFilter}
            onChange={handleChange}
          />
          {/* end product Name */}

          {/* start BARCODE */}
          <TextTableFilter
            id='filter_barcode'
            label={formatMessage({ id: "barcode" })}
            value={barcodeFilter}
            setValue={setBarcodeFilter}
            onChange={handleChange}
          />
          {/* end BARCODE */}

          {/* start MODEL */}
          <TextTableFilter
            id='filter_model'
            label={formatMessage({ id: "model" })}
            value={modelFilter}
            setValue={setModelFilter}
            onChange={handleChange}
          />
          {/* end MODEL */}

          {/* start STATUS */}
          <TextTableFilter
            id='filter_status'
            label={formatMessage({ id: "status" })}
            value={statusFilter}
            setValue={setStatusFilter}
            onChange={handleChange}
            type='select'
            options={[
              {label: formatMessage({ id: "all" }), value: ''},
              {label: formatMessage({ id: "active" }), value: '1'},
              {label: formatMessage({ id: "not_active" }), value: '2'},
            ]}
          />
          {/* end STATUS */}

          {/* start STOCK STATUS */}
          <TextTableFilter
            id='filter_stock'
            label={formatMessage({ id: "stock_status" })}
            value={stockFilter}
            setValue={setStockFilter}
            onChange={handleChange}
            type='select'
            options={[
              {label: formatMessage({ id: "all" }), value: ''},
              {label: formatMessage({ id: "out_of_stock" }), value: '1'},
              {label: formatMessage({ id: "dumyah_out_of_stock" }), value: '2'},
              {label: formatMessage({ id: "supplier_out_of_stock" }), value: '3'},
              {label: formatMessage({ id: "in_stock" }), value: '4'},
              {label: formatMessage({ id: "dumyah_in_stock" }), value: '5'},
              {label: formatMessage({ id: "supplier_in_stock" }), value: '6'},
            ]}
          />
          {/* end STOCK STATUS */}

          {/* start BRAND */}
          <div className='hsb-pl-brand-field'>
            <InputField
              id='filter_brand'
              label={formatMessage({ id: "brand" })}
              value={brandFilter}
              onChange={handleBrandChange}
              type='select'
              options={brandOptions}
              isSearchable={true}
            />
          </div>
          {/* end BRAND */}
          
          
          {/* start Quantity */}
          <TextTableFilter
            id='filter_quantity'
            label={formatMessage({ id: "quantity" })}
            value={qtyFilter}
            setValue={setQtyFilter}
            onChange={handleChange}
          />
          {/* end Quantity */}

          {/* start Special */}
          <TextTableFilter
            id='filter_special'
            label={formatMessage({ id: "special" })}
            value={specialFilter}
            setValue={setSpecialFilter}
            onChange={handleChange}
            type='select'
            options={[
              {label: formatMessage({ id: "all" }), value: ''},
              {label: formatMessage({ id: "with_special" }), value: '1'},
              {label: formatMessage({ id: "without_special" }), value: '0'},
            ]}
          />
          {/* end Special */}

          {/* start Packages — a package (is_offer) is priced and stocked from
              its components, so it behaves differently from ordinary stock and
              is worth isolating. Defaults to All, i.e. the list is unchanged
              until the supplier chooses. */}
          <TextTableFilter
            id='filter_is_package'
            label={formatMessage({ id: "packages" })}
            value={isPackageFilter}
            setValue={setIsPackageFilter}
            onChange={handleChange}
            type='select'
            options={[
              {label: formatMessage({ id: "all" }), value: ''},
              {label: formatMessage({ id: "yes" }), value: '1'},
              {label: formatMessage({ id: "no" }), value: '0'},
            ]}
          />
          {/* end Packages */}

          <div className='hsb-pl-filter-actions'>
            <button
                type='submit'
                className='hsb-pl-apply'
            >
              {formatMessage({id: 'products.list.apply_filters'})}
            </button>
            <button
              type='button'
              className='hsb-pl-reset'
              onClick={clearFilters}
            >
              {formatMessage({ id: "reset" })}
            </button>
          </div>
        </form>
      </div>
      
    </>
  )
}

export default ProductsTableFilter
